import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Paper, Grid, Dialog, DialogTitle, Typography, Button, DialogContent } from "@mui/material";
import { getViewInstance } from "../actions/viewinstance";
import Header from "./layouts/Header";
import Footer from "./layouts/Footer";

import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import ReportCriteria from "./partials/admincenter/ReportCriteria";
import AdminTabs from "./partials/admincenter/AdminTabs";
import ResponsiveRectangle from "./partials/skeletons/ResponsiveRectangle";

import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { FullscreenExit, SettingsPowerRounded } from "@mui/icons-material";
import { fetchGroups, selectGroupSelectTree } from "../reducers/admincenter_groups";
import OrganizationDisplay from "./partials/admincenter/OrganizationDisplay";



const AdminCenterGroups = () => {
    const { mainUser: currentUser } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [callVI, setCallVI] = useState(false)
    const { viewInstance, settings } = useSelector(state => state.viewinstance)


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const admingroupsStatus = useSelector(state => state.admingroups.status)
    const userIsAdmin = (currentUser && (currentUser.IsAdmin === true))

    /*if (!currentUser) {
      return <Navigate to="/login" />;
    }*/

    useEffect(() => {
        if (( userIsAdmin === true) &&
            (admingroupsStatus === 'idle'))
        {
            dispatch(fetchGroups({ authToken: currentUser.AuthToken }))
        }
    }, [userIsAdmin, admingroupsStatus, currentUser, dispatch])


    useEffect(()=>{
        if (userIsAdmin === false)
        {
            navigate('/home')
        }
    },[userIsAdmin, navigate])


    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }

    return (
        <div>
            <Header />

            <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                    <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                        <Paper elevation={1} style={{ marginTop: '150px', padding: '40px' }}>
                            <AdminTabs page="GROUPS" />
                        </Paper>
                    </motion.div>
                </Grid>
                {admingroupsStatus === 'success' ?
                    (
                        <Grid item xs={12}>
                            <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                                <Paper elevation={1} style={{ padding: '40px' }}>
                                    <OrganizationDisplay />
                                </Paper>
                            </motion.div>
                        </Grid>
                    ) : (
                        <Grid item xs={12}>
                            <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                                <Paper elevation={1} style={{ padding: '40px' }}>
                                    <ResponsiveRectangle height="40" />
                                </Paper>
                            </motion.div>
                        </Grid>
                    )
                }



            </Grid>

            <Footer />
        </div >
    )

};

export default AdminCenterGroups;

/*  <Paper elevation={16} style={{marginTop: '100px', padding:'40px'}}>
          <h3>
              HOME
            </h3>
            <Button onClick={logoutUser}>Logout</Button>
            <TermsAndConditions props={TCS.TsAndCsPage}/>
          </Paper> */